export enum NotificationPriority {
  Low = 'low',
  Normal = 'normal',
  High = 'high',
  Critical = 'critical',
}

export interface INotificationData {
  deepLink?: string
  route?: string
  params?: Record<string, any>
  queries?: Record<string, any>
  action?: string
  orgId?: string
  centerId?: string
  additionalData?: Record<string, any>
}

export interface IReceivedNotification {
  id: string
  title?: string
  subtitle?: string
  body: string
  data: INotificationData
  createdUtc: Date
  priority?: NotificationPriority
  notificationType?: string
  isPersistent?: boolean
  entityId?: string
}

export interface IPaginatedNotificationResult {
  items: IReceivedNotification[]
  pageSize: number
  continuationToken: string | null
  hasMore: boolean
}
